import { injectReCaptchaToken } from '@common/Services/recaptcha-service';

const form = () => <JQuery<HTMLFormElement>>$('form');

async function init() {
	form().on('submit', (ev) => injectReCaptchaToken(ev, 'ForgotPassword'));
}

$(init);
